// Unpublished Work © 2020-2022 Deere & Company

import t from 'tcomb';

export const GovernmentTaxId = t.struct({
    countryCode: t.String,
    taxId: t.maybe(t.String),
    taxIdDesc: t.maybe(t.String),
    taxIdType: t.String,
    taxOwnerId: t.maybe(t.String)
}, {
    defaultProps: {
        countryCode: '',
        taxId: '',
        taxIdDesc: '',
        taxIdType: '',
        taxOwnerId: ''
    },
    name: 'GovernmentTaxId'
});
